const SERVER_ADDRESS = "https://dot-back.pfxtools.ru/api";  // TODO: to env

export default SERVER_ADDRESS;
